import { BaseBus } from "./BaseBus";
import { WipReportData } from "./WipReportData";

export class ContractWipReportData extends BaseBus {
    constructor(data: WipReportData = null) {
        super(data);
            this.directCustId = data.directCustId;
            this.directCustOicId = data.directCustOicId;
            this.directCustName = data.directCustName;
            this.locationId = data.locationId;
            this.locationName = data.locationName;
            this.state = data.state;
            this.endUseCustId = data.endUseCustId;
            this.endUseCustOicId = data.endUseCustOicId;
            this.accountClassId = data.accountClassId;
            this.accountClassName = data.accountClassName;
            this.contAccountClassId = data.contAccountClassId;
            this.contAccountClassName = data.contAccountClassName;
            this.contDivisionId = data.contDivisionId;
            this.contDivisionName = data.contDivisionName;
            this.contDivisionSageId = data.contDivisionSageId;
            this.JobNbr = data.JobNbr;
            this.jobId = data.jobId;
            this.pMId = data.pMId;
            this.pMEmpNo = data.pMEmpNo;
            this.pMName = data.pMName;
            this.contPMId = data.contPMId;
            this.contPMEmpNo = data.contPMEmpNo;
            this.contPMName = data.contPMName;
            this.contPMEmpId = data.contPMEmpId;
            this.contractNbr = data.contractNbr;
            this.contractId = data.contractId;
            this.contDispatchStatusId = data.contDispatchStatusId;
            this.contDispatchStatusName = data.contDispatchStatusName;
            this.dispatchStatusId = data.dispatchStatusId;
            this.dispatchStatusName = data.dispatchStatusName;
            this.tAndM = data.tAndM;
            this.tAndMProfitPerc = data.tAndMProfitPerc;
            this.contractDate = data.contractDate;
            this.projectedEndDate = data.projectedEndDate;
            this.contractCloseDate = data.contractCloseDate;
            this.contractAmount = data.contractAmount;
            this.estimatedContractMaterialCosts = data.estimatedContractMaterialCosts;
            this.estimatedContractLaborCosts = data.estimatedContractLaborCosts;
            this.estimatedContractOtherCosts = data.estimatedContractOtherCosts;
            this.estimatedContractPendingCRCosts = data.estimatedContractPendingCRCosts;
            this.pmEstimateAdjustments = data.pmEstimateAdjustments;
            this.contractAdjustments = data.contractAdjustments;
            this.currentCostAdjustments = data.currentCostAdjustments;
            this.btdAdjustments = data.btdAdjustments;
            this.lastSixZeroSixAdjustment = data.lastSixZeroSixAdjustment;
            this.committedCosts = data.committedCosts;
            this.bidHrs = data.bidHrs;
            this.actHrs = data.actHrs;
            this.totalCurrentMaterialCosts = data.totalCurrentMaterialCosts;
            this.totalCurrentLaborCosts = data.totalCurrentLaborCosts;
            this.totalCurrentOtherCosts = data.totalCurrentOtherCosts;
            this.billedToDate = data.billedToDate;
            this.divisionId = data.divisionId;
            this.divisionName = data.divisionName;
            this.divisionSageId = data.divisionSageId
    }
    directCustId;
    directCustOicId;
    directCustName;
    locationId;
    locationName;
    state;
    endUseCustId;
    endUseCustOicId;
    accountClassId;
    accountClassName;
    contAccountClassId;
    contAccountClassName;
    contDivisionId;
    contDivisionName;
    contDivisionSageId;
    JobNbr;
    jobId;
    pMId;
    pMEmpNo;
    pMName;
    contPMId;
    contPMEmpNo;
    contPMName;
    contPMEmpId;
    contractNbr;
    contractId;
    contDispatchStatusId;
    contDispatchStatusName;
    dispatchStatusId;
    dispatchStatusName;
    tAndM;
    tAndMProfitPerc;
    contractDate;
    projectedEndDate;
    contractCloseDate;
    get hasEstimatedFields() {
        if (this.estimatedContractMaterialCosts && this.estimatedContractLaborCosts && this.estimatedContractOtherCosts && this.estimatedContractPendingCRCosts && this.pmEstimateAdjustments && this.estimatedContractMaterialCosts > 0 && this.estimatedContractLaborCosts > 0 && this.estimatedContractOtherCosts > 0 && this.pmEstimateAdjustments > 0) {
            return true;
        }
        else {
            return false;
        }
    }
    get percComplete() {
        //if (this.hasEstimatedFields) {
        //    return this.totalCurrentCosts / (this.totalEstimatedContractCosts)
        //} else { return 0 }
        if (!this.totalEstimatedContractCosts || (this.totalEstimatedContractCosts && this.totalEstimatedContractCosts == 0)) {
            return 0;
        }
        else {
            return ((this.totalCurrentCosts / (this.totalEstimatedContractCosts)) < 1 ? (this.totalCurrentCosts / (this.totalEstimatedContractCosts)) : 1);
        }
    };
    //percCompleteScaled;
    contractAmount;
    get totalEstimatedContractCosts() { return (this.estimatedContractMaterialCosts + this.estimatedContractLaborCosts + this.estimatedContractOtherCosts + this.estimatedContractPendingCRCosts + this.pmEstimateAdjustments) };
    estimatedContractMaterialCosts;
    estimatedContractLaborCosts;
    estimatedContractOtherCosts;
    estimatedContractPendingCRCosts
    pmEstimateAdjustments;
    ////
    get TandMContractAmount() {
        return this.adjCurrentCosts * (this.tAndMProfitPerc && this.tAndM ? (this.tAndMProfitPerc > 0 ? this.tAndMProfitPerc : 0) : 0);
    }
    contractAdjustments;
    get adjContAmount() {
        return this.contractAmount + this.TandMContractAmount + this.contractAdjustments;
    }
    get adjEstAmount() {
        return this.totalEstimatedContractCosts; //+ this.pmEstimateAdjustments;
    }
    get tandMEstimate() {
        return this.tAndM ? this.committedCosts : 0;
    }
    get percBidLaborHrsIncurred() {
        return ((this.actHrs && this.bidHrs && this.actHrs > 0 && this.bidHrs > 0) ? (this.actHrs / this.bidHrs) : 0);
    }
    get percBidLaborDollarsIncurred() {
        //return ((this.totalCurrentLaborCosts && this.estimatedContractLaborCosts && this.totalCurrentLaborCosts > 0 && this.estimatedContractLaborCosts > 0) ? (this.totalCurrentLaborCosts / this.estimatedContractLaborCosts) : 0);
        return this.totalCurrentLaborCosts / this.estimatedContractLaborCosts;
    }
    get sixzerosixEntry() {
        //Deselect for all Sub branches
        //Deselect all contracts with Mgmt Construction class
        //Deselect if 'Current Contract Material Costs' are zero
        //Deselect all jobs that are 100 % complete
        //Deselect all jobs where actual labor hours are 10 % or greater of Quote hours
        //Deselect all jobs where actual labor $ are 10 % or greater of "Total Current Labor Costs"
        //Override if sizzerosix adjustment exists
        if (this.lastSixZeroSixAdjustment || this.contAccountClassId.toUpperCase() == '8F7207DF-BD68-4E40-9650-056BDE0A2D2E' || this.contAccountClassId.toUpperCase() == 'DE5AFB0E-5066-41D0-8BB0-5D2C73062D8A'
            || this.contAccountClassId.toUpperCase() == '1DCBD91B-C260-4225-8926-6A848A03FB20' || this.contAccountClassId.toUpperCase() == '4D78EEF0-265F-4FEF-99B9-8B7AEBBE871B'
            || this.totalCurrentMaterialCosts == 0 || this.percComplete >= 1 || (this.percBidLaborHrsIncurred >= 0.1) || (this.percBidLaborDollarsIncurred >= 0.1)
            || this.contDivisionSageId.includes('99')) {
            return false;
        } else {
            return true;
        }
    }
    currentCostAdjustments;
    get adjCurrentCosts() {
        return this.totalCurrentCosts + this.currentCostAdjustments;
    }
    btdAdjustments;
    get adjBTD() {
        return this.billedToDate + this.btdAdjustments;
    } 
    lastSixZeroSixAdjustment;
    get changeInPMContract() {
        return 0;
    }
    get changeInPMEstimate() {
        return 0;
    }
    get changeInPMCost() {
        return 0;
    }
    get changeInPMBilled() {
        return 0;
    }
    /////
    get projectedGrossProfit() { return (this.contractAmount - (this.totalEstimatedContractCosts)) };
    get totGrossProfitPerc() {
        if (!this.contractAmount || (this.contractAmount && this.contractAmount == 0)) {
            return 0;
        } else {
            return (this.contractAmount - (this.totalEstimatedContractCosts)) / this.contractAmount;
        }
    };
    committedCosts;
    get jobsWCommittedCostsGTEstimatedCostsLTD() { return (this.totalEstimatedContractCosts) - this.committedCosts };
    bidHrs;
    actHrs;
    get percLaborhoursTD() {
        if (this.bidHrs && this.bidHrs > 0) {
            return this.actHrs / this.bidHrs
        } else { return 0 }
    };
    get contractRevenue() {
        //if (this.hasEstimatedFields) {
        //    return this.contractAmount * (this.totalCurrentCosts / (this.totalEstimatedContractCosts))
        //} else { return 0 }
        if ((this.percComplete) <= 1) {
            return this.contractAmount * (this.percComplete);
        } else {
            //return 1;
            return this.contractAmount;
        }
    };
    //contractRevenueScaled;
    get totalCurrentCosts() { return this.totalCurrentMaterialCosts + this.totalCurrentLaborCosts + this.totalCurrentOtherCosts };
    totalCurrentMaterialCosts;
    totalCurrentLaborCosts;
    totalCurrentOtherCosts;
    get currentGrossProfit() {
        //if (this.hasEstimatedFields) {
        //    return (this.contractRevenue) - (this.totalCurrentCosts)
        //} else { return 0 }
        return (this.contractRevenue) - (this.totalCurrentCosts);
    };
    billedToDate;
    //billedToDateScaled;
    get billingsInExcessCostsEstEarningsCostEstEarningsExcessBillings() {
        //if (this.hasEstimatedFields) {
        //    return (this.billedToDate) - (this.contractRevenue)
        //} else { return 0 }
        return (this.billedToDate) - (this.contractRevenue);
    };
    get backlog() {
        //if (this.hasEstimatedFields) {
        //    return this.contractAmount - (this.contractRevenue)
        //} else { return 0 }
        return this.contractAmount - (this.contractRevenue);
    };
    get totalCostsToComplete() { return (this.totalEstimatedContractCosts) - (this.totalCurrentCosts) };
    get totalMaterialCostsToComplete() { return this.estimatedContractMaterialCosts - this.totalCurrentMaterialCosts};
    get totalLaborCostsToComplete() { return this.estimatedContractLaborCosts - this.totalCurrentLaborCosts};
    get totalOtherCostsToComplete() { return this.estimatedContractOtherCosts + this.pmEstimateAdjustments - this.totalCurrentOtherCosts};
    get totalAdjustmentsToBeComplete() { return this.pmEstimateAdjustments };
    get grossProfit() {
        //if (this.hasEstimatedFields) {
        //    return (this.backlog) - (this.totalCostsToComplete)
        //} else { return 0 }
        return (this.backlog) - (this.totalCostsToComplete);
    };
    get grossProfitPerc() {
        //if (this.contractAmount && this.contractAmount > 0 && this.hasEstimatedFields) {
        //    return (this.grossProfit / this.backlog)
        //} else { return 0 }
        if (!this.backlog || (this.backlog && this.backlog == 0)) {
            return 0;
        } else {
            return (this.grossProfit / this.backlog);
        }
    };
    get amountNotYetBilled() {
        //if (this.hasEstimatedFields) {
        //    return ((this.contractAmount) - (this.billedToDate))
        //} else { return 0 }
        return ((this.contractAmount) - (this.billedToDate));
    };
    //get paidToDate() { return };
    divisionId;
    divisionName;
    divisionSageId;
    glCode;
    subjobs?: WipReportData[] = [];
}
